module.exports = __webpack_public_path__ + "img/profile_picture.31728055.jpg";